export default "__VITE_ASSET__BkbOr$gR__"